import { RouteComponentProps, useHistory } from "react-router-dom";
import { PayeeRequirementDetails } from "./PayeeRequirementDetails";
import { WSPage } from "@wingspanhq/fe-component-library";
import { WSQueries } from "../../../../../query/WSQuery";
import { Fullscreen } from "../../../../../components/Fullscreen/Fullscreen";
import { queriesRequirements } from "@query";

export const DASHBOARD_PAYEE_REQUIREMENT_DETAILS_PATH =
  "/member/dashboard/payee/:payeeId/requirement/:requirementId";

export const useGoToDashboardPayeeRequirementDetails = () => {
  const history = useHistory();
  return (params: { payeeId: string; requirementId: string }) => {
    history.push(
      DASHBOARD_PAYEE_REQUIREMENT_DETAILS_PATH.replace(
        ":payeeId",
        params.payeeId
      ).replace(":requirementId", params.requirementId)
    );
  };
};

export const RoutePayeeRequirementDetails: React.FC<
  RouteComponentProps<{
    payeeId: string;
    requirementId: string;
  }>
> = ({
  match: {
    params: { requirementId }
  }
}) => {
  const queryRequirement = queriesRequirements.getPayeeRequirement.useQuery({
    requirementId
  });

  return (
    <Fullscreen>
      <WSPage>
        <WSQueries
          queries={{
            queryRequirement
          }}
        >
          {({ queryRequirementData }) => {
            return (
              <PayeeRequirementDetails requirement={queryRequirementData} />
            );
          }}
        </WSQueries>
      </WSPage>
    </Fullscreen>
  );
};
